// Project portfolio — all clients & project names verbatim from the business document.

export const PROJECT_GROUPS = [
  {
    id: "defence",
    industry: "Defence",
    intro:
      "Mission-critical submarine, naval and land-systems components delivered to inspection and third-party approval standards.",
    projects: [
      {
        title: "Truck Mounted Gun — Cradle & Base Frame",
        client: "Tata Power",
        detail:
          "Aluminium artillery cradle and base frame assemblies, engineered for durability and recoil management in truck-mounted gun (TMG) systems.",
        images: [
          "/assets/images/defence/truck_mounted_gun_tata_power_3.jpg",
          "/assets/images/defence/truck_mounted_gun_tata_power_1.jpg",
          "/assets/images/defence/truck_mounted_gun_tata_power_2.jpg",
        ],
      },
      {
        title: "Upper & Lower Rudder Assemblies",
        client: "Mazagon Dock Limited (MDL)",
        detail:
          "Mission-ready rudder assemblies for naval vessels, precision-manufactured for critical steering and manoeuvring performance.",
        images: [
          "/assets/images/defence/rudder_assembly_mdl_navy_1.jpg",
          "/assets/images/defence/rudder_assembly_mdl_navy_2.jpg",
          "/assets/images/defence/rudder_assembly_mdl_1.jpg",
        ],
      },
      {
        title: "Sonar Domes (316Ti)",
        client: "Mazagon Dock Limited (MDL)",
        detail:
          "Corrosion-resistant sonar dome structures in 316Ti alloy, optimized for acoustic performance and high-stress naval service.",
        images: [
          "/assets/images/defence/sonar_dome_mdl_1.jpg",
          "/assets/images/defence/sonar_dome_mdl_3.jpg",
        ],
      },
      {
        title: "Fin Stabilizers & Stabilizer Structures — P-15A",
        client: "L&T Marine",
        detail:
          "Specialized fin stabilizer structures for P-15A naval platforms, built for high-performance sea-keeping and stabilization.",
        images: [
          "/assets/images/marine/fin_stabilizers_lt_marine_1.jpg",
          "/assets/images/marine/fin_stabilizers_lt_marine_2.jpg",
          "/assets/images/marine/fin_stabilizers_lt_marine_3.jpg",
        ],
      },
      {
        title: "Stabilizer Cartridge — P-15A",
        client: "MDL / L&T Marine",
        detail:
          "Precision stabilizer cartridge assemblies for the P-15A project, manufactured with liquid-nitrogen shrink fitting for maximum reliability.",
        images: [
          "/assets/images/marine/stabilizer_cartridge_mdl_lt_1.jpg",
          "/assets/images/marine/stabilizer_cartridge_mdl_lt_2.jpg",
          "/assets/images/marine/stabilizer_cartridge_mdl_lt_3.jpg",
        ],
      },
      {
        title: "Hatch Doors for Army Tanks",
        client: "L&T Weapon",
        detail:
          "Heavy-duty armoured hatch doors and subassemblies for land-based defence equipment and combat vehicles.",
        images: [
          "/assets/images/defence/hatch_doors_army_tanks_lt_weapon.jpg",
        ],
      },
      {
        title: "Pinaka Multi-Barrel Rocket Launcher — Base Structure",
        client: "Tata Power",
        detail:
          "Structural-grade base assemblies for the Pinaka MBRL system, built to withstand extreme operational forces.",
        images: [
          "/assets/images/defence/pinaka_base_tata_power_1.jpg",
          "/assets/images/defence/pinaka_base_tata_power_2.jpg",
        ],
      },
    ],
  },
  {
    id: "marine",
    industry: "Marine & Offshore",
    intro:
      "High-tolerance assemblies for naval platforms and offshore equipment, serving a growing international client base including Royal IHC.",
    projects: [
      {
        title: "Winch Drums & Frame",
        client: "Royal IHC",
        detail:
          "Custom winch assemblies for heavy-duty marine applications, engineered for high-load reliability in dredging and mooring systems.",
        images: [
          "/assets/images/marine/royalihc_winch_drums_1.jpg",
          "/assets/images/marine/royalihc_winch_drums_2.jpg",
          "/assets/images/marine/royalihc_winch_drums_3.jpg",
          "/assets/images/marine/royalihc_winch_drums_4.jpg",
          "/assets/images/marine/royalihc_winch_drums_5.jpg",
          "/assets/images/marine/royalihc_winch_drums_6.jpg",
          "/assets/images/marine/royalihc_winch_drums_7.jpg",
          "/assets/images/marine/royalihc_winch_drums_8.jpg",
          "/assets/images/marine/royalihc_winch_frame.jpg",
        ],
      },
      {
        title: "Dredger Pipes & Expansion Pieces",
        client: "Royal IHC",
        detail:
          "Dredger vessel piping and expansion pieces, built for heavy-wear environments and high-volume suction/discharge lines.",
        images: [
          "/assets/images/marine/royalihc_dredger_pipe_2.jpg",
          "/assets/images/marine/royalihc_dredger_pipe_1.jpg",
          "/assets/images/marine/royalihc_dredger_expansion.jpg",
          "/assets/images/marine/royalihc_dredger_inspection_1.jpg",
          "/assets/images/marine/royalihc_dredger_inspection_3.jpg",
        ],
      },
      {
        title: "Dredger Loading Box",
        client: "Royal IHC",
        detail:
          "Heavy-fabricated loading boxes for trailing suction hopper dredgers, optimized for efficient material handling and flow control.",
        images: [
          "/assets/images/marine/dredger_loading_box_royalihc.jpg",
          "/assets/images/marine/loading_box.jpg",
        ],
      },
      {
        title: "Cardan Ring",
        client: "Royal IHC",
        detail:
          "Precision-machined cardan rings for maritime propulsion systems, ensuring reliable torque transmission for drive and coupling assemblies.",
        images: [
          "/assets/images/marine/cardan_ring1.jpg",
          "/assets/images/marine/cardan_ring2.jpg",
        ],
      },
      {
        title: "A-Frame",
        client: "Royal IHC",
        detail:
          "Structural A-frame support systems for marine lifting and handling, designed for stability in heavy-lift deck operations.",
        images: [
          "/assets/images/marine/A-frame.jpg",
        ],
      },
      {
        title: "Trunnion Gantry",
        client: "Royal IHC",
        detail:
          "Heavy-duty trunnion gantry structures for offshore lifting and handling systems, precision-aligned for mission-critical vessel integration.",
        images: [
          "/assets/images/marine/trunnion_gantry.jpg",
        ],
      },
      {
        title: "Submarine Hydroplanes",
        client: "Mazagon Dock Limited (MDL)",
        detail:
          "Forward and starboard submarine hydroplane control surfaces, precision-fabricated to naval mission-critical standards.",
        images: [
          "/assets/images/additional/submarine_hydroplane_mdl.png",
          "/assets/images/marine/hydroplane_mdl_1.jpg",
          "/assets/images/marine/hydroplane_mdl_2.jpg",
          "/assets/images/marine/hydroplane_mdl_3.jpg",
          "/assets/images/marine/hydroplane_mdl_4.jpg",
          "/assets/images/marine/hydroplane_mdl_6.jpg",
          "/assets/images/marine/hydroplane_mdl_fwd_1.jpg",
          "/assets/images/marine/hydroplane_mdl_fwd_2.jpg",
        ],
      },
      {
        title: "Ship Gantry — Fixed Part",
        client: "Royal IHC",
        detail:
          "Heavy-fabricated fixed gantry structures for maritime lifting and handling systems, built to rigorous TPA and client specifications.",
        images: [
          "/assets/images/marine/ship_gantry_royal_ihc_2.webp",
          "/assets/images/marine/ship_gantry_royal_ihc_1.webp",
        ],
      },
      {
        title: "Fin Stabilizer Assemblies",
        client: "L&T Marine",
        detail:
          "Advanced fin stabilizer assemblies engineered for naval vessel stability and performance in demanding offshore conditions.",
        images: [
          "/assets/images/defence/rudder_assembly_mdl_navy_3.jpg",
          "/assets/images/defence/rudder_assembly_mdl_2.jpg",
        ],
      },
      {
        title: "Propeller Caps",
        client: "Royal IHC",
        detail:
          "Precision-machined maritime propulsion components, ensuring optimal hydrodynamic performance for submarine and surface vessel assemblies.",
        images: [
          "/assets/images/marine/prop_cap_1.jpg",
          "/assets/images/marine/prop_cap_2.jpg",
        ],
      },
      {
        title: "Shrink Fitting — Liquid Nitrogen",
        client: "L&T Marine",
        detail:
          "Exacting cryogenic shrink-fitting using liquid nitrogen to achieve high-precision interference fits for critical naval assemblies.",
        images: [
          "/assets/images/marine/shrink_fitting_liquid_nitrogen_1.jpg",
          "/assets/images/marine/shrink_fitting_liquid_nitrogen_2.jpg",
        ],
      },
    ],
  },
  {
    id: "steel",
    industry: "Steel & Heavy Engineering",
    intro:
      "Assemblies and machined components for continuous casting, rolling and metals-processing lines worldwide.",
    projects: [
      {
        title: "Mould Assembly — Round Section",
        client: "SMS Zurich",
        detail: "Precision round-section mould assemblies for continuous casting lines, engineered for high-heat durability and operational accuracy.",
        images: [
          "/assets/images/steel/mould_assembly_round_sms_zurich_1.jpg",
          "/assets/images/steel/mould_assembly_round_sms_zurich_2.jpg",
          "/assets/images/steel/mould_assembly_round_sms_zurich_3.jpg",
        ],
      },
      {
        title: "Mould Assembly — Square Section",
        client: "SMS Zurich",
        detail: "Square-section mould assemblies for steel casting, custom-fabricated for continuous metal processing efficiency.",
        images: [
          "/assets/images/steel/mould_assembly_square_sms_zurich_1.jpg",
          "/assets/images/steel/mould_assembly_square_sms_zurich_2.jpg",
          "/assets/images/steel/mould_assembly_square_sms_zurich_3.jpg",
        ],
      },
      {
        title: "Pay-off Reel Assembly",
        client: "Tenova Metals",
        detail: "Heavy-duty pay-off reel assemblies for metals processing and strip lines, built for reliable high-tension material handling.",
        images: [
          "/assets/images/steel/payoff_reel_assembly_tenova_1.jpg",
          "/assets/images/steel/payoff_reel_assembly_tenova_2.jpg",
          "/assets/images/steel/payoff_reel_assembly_tenova_3.jpg",
        ],
      },
      {
        title: "Winch Drum",
        client: "John Cockerill (formerly CMI)",
        detail: "Custom-fabricated heavy winch drums for metals processing equipment and industrial lifting applications.",
        images: [
          "/assets/images/steel/winch_drum_john_cockerill_1.jpg",
          "/assets/images/steel/winch_drum_john_cockerill_2.jpg",
        ],
      },
      {
        title: "Bridle Roll Assembly",
        client: "John Cockerill",
        detail: "Precision bridle roll assemblies for strip processing lines, ensuring consistent tension control and material flow.",
        images: ["/assets/images/steel/bridle_roll_assembly_john_cockerill.jpg"],
      },
      {
        title: "Withdrawal Straightening Unit",
        client: "SMS India",
        detail: "Critical withdrawal and straightening units for continuous casting lines, engineered for precision metallurgical processing.",
        images: [
          "/assets/images/steel/withdrawal_straightening_unit_sms_india_1.jpg",
          "/assets/images/steel/withdrawal_straightening_unit_sms_india_2.jpg",
        ],
      },
      {
        title: "Segments (Steel Casting Components)",
        client: "SMS India",
        detail: "High-tolerance precision segment assemblies for large-scale continuous casting operations.",
        images: [
          "/assets/images/steel/segments_sms_india_1.jpg",
          "/assets/images/steel/segments_sms_india_2.jpg",
          "/assets/images/steel/segments_sms_india_3.jpg",
        ],
      },
      {
        title: "Cross Transfer Mechanism",
        client: "SMS India",
        detail: "Automated cross-transfer mechanisms for industrial material handling and metal processing line integration.",
        images: [
          "/assets/images/steel/cross_transfer_mechanism_sms_india_1.jpg",
          "/assets/images/steel/cross_transfer_mechanism_sms_india_2.jpg",
        ],
      },
      {
        title: "Roof Lifting Mechanism",
        client: "SMS Concast",
        detail: "Heavy-duty roof lifting mechanisms for industrial furnace applications, built for high-heat performance and reliability.",
        images: [
          "/assets/images/steel/roof_lifting_mechanism_sms_concast_1.jpg",
          "/assets/images/steel/roof_lifting_mechanism_sms_concast_2.jpg",
        ],
      },
      {
        title: "Toggle Shear, Pinch Roll & Stacking Lances",
        client: "Primetals",
        detail: "Integrated shearing and handling assemblies for metal strip lines, precision-built for automated processing.",
        images: [
          "/assets/images/steel/toggle_shear_pinch_roll_primetals_1.jpg",
          "/assets/images/steel/toggle_shear_pinch_roll_primetals_2.jpg",
        ],
      },
      {
        title: "Deflector Roll Arm",
        client: "CMI",
        detail: "Custom-fabricated deflector roll arm assemblies for industrial strip processing and material guidance.",
        images: [
          "/assets/images/steel/deflector_roll_arm_cmi_1.jpg",
          "/assets/images/steel/deflector_roll_arm_cmi_2.jpg",
          "/assets/images/steel/deflector_roll_arm_cmi_3.jpg",
        ],
      },
      {
        title: "Laminated Hooks",
        client: "Mukand Steel Ltd",
        detail: "Structural laminated hooks for heavy-lift industrial applications, engineered for maximum load safety and durability.",
        images: ["/assets/images/steel/laminated_hooks_mukand_steel.jpg"],
      },
      {
        title: "Hub Skirt Assembly — Jaypee Nigrie Thermal Powerplant",
        client: "L&T MHI Boilers Pvt Ltd",
        detail: "Critical hub skirt assemblies for thermal power plant boilers, engineered for high-temperature structural integrity.",
        images: ["/assets/images/steel/hub_skirt_assembly_jaypee_lt_mhi.jpg"],
      },
      {
        title: "Heligrid",
        client: "L&T",
        detail: "Specialized heligrid structural components, precision-engineered to exacting technical specifications for power and process applications.",
        images: ["/assets/images/marine/heligrid_lt.jpg"],
      },
    ],
  },
];

// Additional precision components note (from document)
export const ADDITIONAL_NOTE =
  "Our portfolio also includes a wide range of precision components such as bearing housings, flanged pipe/valve components and ring-shaped machined parts — reflecting broad capability across sectors.";

export const ADDITIONAL_IMAGES = [
  "/assets/images/additional/additional5.jpeg",
  "/assets/images/additional/additional_extra_1.jpg",
  "/assets/images/additional/additional_extra_2.jpg",
  "/assets/images/additional/additional_extra_3.jpg",
  "/assets/images/additional/additional_extra_4.jpg",
  "/assets/images/additional/additional_extra_6.jpg",
  "/assets/images/additional/additional_extra_7.jpg",
  "/assets/images/additional/additional_projects_1.jpg",
  "/assets/images/additional/additional_projects_2.jpg",
  "/assets/images/additional/additional_projects_3.jpg",
];
